import axios from 'axios'

export const exportReq = (params) =>
  axios.get(`/export`, {
    params,
  })
